import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { getAuthSession, hasAnyPermission, hasRequiredRole, isTokenExpired } from '../auth';

function AccessDenied() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 3, bgcolor: '#f6f8fb' }}>
      <Card sx={{ maxWidth: 520, width: '100%', borderRadius: 4, boxShadow: '0 18px 50px rgba(31,45,72,0.14)' }}>
        <CardContent sx={{ p: 4, display: 'grid', gap: 2 }}>
          <Typography variant="h5" sx={{ fontWeight: 900, color: '#172b4d' }}>
            Acces non autorise
          </Typography>
          <Typography variant="body2" sx={{ color: '#637083' }}>
            Votre role ne dispose pas des droits necessaires pour ouvrir cette page. Demandez a un administrateur de verifier Rollen & Rechte.
          </Typography>
          <Button variant="contained" href="/dashboard" sx={{ justifySelf: 'flex-start' }}>
            Retour au tableau de bord
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}

export default function ProtectedRoute({ children, allowedRoles = [], requireGlobalAdmin = false, requiredPermissions = [] }) {
  const location = useLocation();
  const session = getAuthSession();

  if (!session.token || isTokenExpired(session.token)) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!hasRequiredRole(session.role, allowedRoles, {
    isSuperUser: session.isSuperUser,
    requireGlobalAdmin,
  })) {
    return <AccessDenied />;
  }

  if (!hasAnyPermission(requiredPermissions, session)) {
    return <AccessDenied />;
  }

  return children;
}
